<template>
    <span>{{ timerPretty }}</span>
</template>
<script>
import { ChronoUnit, Instant } from '@js-joda/core';
import { mapGetters } from 'vuex';

export default {
    name: 'Timer',
    data() {
        return {
            remainedSeconds: 0,
            timer: null,
        };
    },
    computed: {
        ...mapGetters('booking', ['getExpiresAt']),
        expiresAt() {
            return this.getExpiresAt;
        },
        timerPretty() {
            const sec = this.remainedSeconds;
            const h = Math.trunc(sec / 3600);
            let m = Math.trunc((sec % 3600) / 60);
            let s = Math.trunc(sec % 60);
            m = m < 10 ? `0${m}` : m;
            s = s < 10 ? `0${s}` : s;
            return `${h}:${m}:${s}`;
        },
    },
    methods: {
        updateSeconds() {
            const expiresAt = Instant.parse(this.expiresAt);
            this.remainedSeconds = Instant.now().until(expiresAt, ChronoUnit.SECONDS);
            if (this.remainedSeconds <= 0) {
                this.error = 'session_expired';
                clearInterval(this.timer);
            }
        },
    },
    created() {
        this.timer = setInterval(this.updateSeconds, 1000);
    },
};
</script>
